export const panelStyles = {
  root: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    // Full-height drawer: pad content below the Dynamic Island so the header
    // (close control) isn't under the pill on iPhone (viewport-fit=cover).
    paddingTop: 'env(safe-area-inset-top, 0px)',
    // AEGIS P3-01: also clear the home indicator at the bottom edge.
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    width: 'min(420px, 100vw)',
    background: 'var(--glass)',
    borderLeft: '1px solid var(--stodob)',
    boxShadow: '-8px 0 24px rgba(0,0,0,0.18)',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 13,
    color: 'var(--navy)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderBottom: '1px solid var(--stodob)',
  },
  title: { fontWeight: 600, fontSize: 15 },
  closeBtn: {
    minHeight: 44,
    minWidth: 44,
    padding: '8px 12px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: 'var(--navy)',
    borderRadius: 8,
  },
  tabs: {
    display: 'flex',
    gap: 4,
    padding: '8px 12px',
    borderBottom: '1px solid var(--stodob)',
  },
  tab: {
    minHeight: 44,
    padding: '8px 12px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: 'var(--tm)',
    borderRadius: 8,
    textTransform: 'capitalize',
  },
  tabActive: {
    background: 'var(--navy-surface)',
    color: 'white',
  },
  body: {
    flex: 1,
    overflowY: 'auto',
    padding: 16,
  },
  section: { marginTop: 16 },
  btn: {
    minHeight: 44,
    padding: '8px 12px',
    border: 'none',
    background: 'var(--navy-surface)',
    color: 'white',
    cursor: 'pointer',
    borderRadius: 8,
  },
  logList: { listStyle: 'none', padding: 0, marginTop: 12 },
  logRow: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 0',
    borderBottom: '1px solid var(--stodob)',
  },
  logType: { fontWeight: 600, fontSize: 12 },
  logMsg: { fontSize: 12, color: 'var(--tm)' },
  logTime: { fontSize: 11, color: 'var(--tm)' },
  pre: {
    marginTop: 12,
    padding: 12,
    background: 'var(--stodob)',
    borderRadius: 8,
    fontSize: 11,
    overflow: 'auto',
    maxHeight: 360,
  },
};
